<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="Existing group" name="existingGroup">
        <select-send-list
          ref="selectSendList"
          :search-url="searchUrl"
          :import-url="importUrl"
          @stored="onImportedSuccess"
        ></select-send-list>
      </el-tab-pane>
      <el-tab-pane label="Create group" name="createGroup">
        <create-send-list
          ref="createSendList"
          :can-select-user="canSelectUser"
          :users="users"
          :store-url="storeUrl"
          @stored="onStoredSendList"
        ></create-send-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BaseForm from '../../form';
import SelectSendList from "./select-send-list";
import CreateSendList from "./create-send-list";

export default {
  extends: BaseForm,

  components: {
    SelectSendList,
    CreateSendList,
  },

  props: {
    importUrl: String,
    searchUrl: String,
    canSelectUser: Boolean,
    users: Array,
    storeUrl: String,
  },

  data() {
    return {
      activeName: 'existingGroup',
    };
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      if (_.isEmpty(model)) {
        return;
      }

      this.$refs.createSendList.initForm(model);
    },

    /**
     * @param data
     * @emits stored
     */
    onImportedSuccess(data) {
      this.$emit('stored', data);
    },

    /**
     * @param model
     */
    onStoredSendList(model) {
      this.activeName = 'existingGroup';
      this.$refs.selectSendList.setUpOption(model);
    },
  },
}
</script>

<style scoped>

</style>
